import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Match } from '../Main.Model';
import { DataService } from '../data.service';
import { FunctionService } from '../function.service';
import { APIService } from '../api.service';

@Component({
    selector: 'app-draw',
    templateUrl: './draw.component.html',
    styleUrl: './draw.component.css',
    standalone: false
})
export class DrawComponent implements OnChanges {

  @Input('MatchesKO4') MatchesKO4: Match[] = [];
  @Input('MatchesKO8') MatchesKO8: Match[] = [];
  @Input('MatchesKO16') MatchesKO16: Match[] = [];
  @Input('MatchesKO32') MatchesKO32: Match[] = [];
  //isPlate: boolean = false;
  DrawSection: 'Main' | 'Plate' | 'Conso' = 'Main';
  KO4DrawReady: boolean = false;
  KO8DrawReady: boolean = false;
  KO16DrawReady: boolean = false;
  KO32DrawReady: boolean = false;
  isKO8Draw: boolean = false;
  isKO16Draw: boolean = false;
  isKO32Draw: boolean = false;
  isEditing: boolean = false;
  ko32SlotsR1List = this.ko32SlotsR1();
  ko32SlotsR2List = this.ko32SlotsR2();
  //has8Plate: boolean = false;
  //has16Plate = true;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['MatchesKO4'] && this.MatchesKO4) {
      this.KO4DrawReady = true;
    }
    if (changes['MatchesKO8'] && this.MatchesKO8) {
      this.KO8DrawReady = true;
      this.isKO8Draw = true;
    }
    if (changes['MatchesKO16'] && this.MatchesKO16) {
      this.KO16DrawReady = true;
      //this.has8Plate = true;
      this.isKO16Draw = true;
    } 
    if (changes['MatchesKO32'] && this.MatchesKO32) {
      this.KO32DrawReady = true;
      //this.has16Plate = true;
      this.isKO32Draw = true;
    }
  }

  constructor(public DataService: DataService, private FunctionService: FunctionService, private ApiService: APIService) {   }

  async EnterScore(matchNumber: number, subDraw = 0) {
    const match = await this.FindMatch(matchNumber, subDraw);
    this.DataService.SelectedMatch = match || (undefined as any);
    
    if (this.DataService.SelectedMatch && this.DataService.SelectedMatch.player1Name != "" && this.DataService.SelectedMatch.player2Name != "") {
        this.DataService.isEditingMatchScore = true;
        this.FunctionService.calculateScores(this.DataService.SelectedMatch);
        setTimeout(() => {
          document.getElementById("Score11")?.focus();
          //now select the text inside the input box
          (document.getElementById("Score11") as HTMLInputElement).select();
        }, 500);
    } else {
        this.DataService.SelectedMatch = undefined as any;
    }
  }

  async mouseover(matchNumber:any, subDraw = 0) {
    if (this.DataService.isEditingMatchScore == false) {
        const match = await this.FindMatch(matchNumber, subDraw);
        this.DataService.SelectedMatch = match || (undefined as any);
        if (this.DataService.SelectedMatch && (this.DataService.SelectedMatch.player1Name == "" || this.DataService.SelectedMatch.player2Name == "")) {
            this.DataService.SelectedMatch = undefined as any;
        } else {
            this.FunctionService.calculateScores(this.DataService.SelectedMatch!);
        }
    }
  }

  mouseLeft() {
    if (this.DataService.isEditingMatchScore == false) {
        this.DataService.SelectedMatch = undefined as any;
    }
  }

  FindMatch(matchNumber: number, subDraw: number) {
    if (matchNumber) {
      var MatchesToSearch = [] as Match[];
      if (this.isKO16Draw == true) {
          MatchesToSearch = this.MatchesKO16;
      } else if(this.isKO32Draw == true) {
            MatchesToSearch = this.MatchesKO32;
      } else if(this.KO8DrawReady == true) {
            MatchesToSearch = this.MatchesKO8;
      }
      return MatchesToSearch.find(
          (m: any) =>
          m &&
          typeof m === 'object' &&
          'matchNo' in m &&
          m.matchNo === matchNumber &&
          m.subDrawNumber === subDraw
      ) ?? null;
    }
}

  changeToPlateDraw() {
    //this.DrawSection = "Plate";
    if (this.isKO16Draw == true) {
      // I need to disperse the plate matches from this.MatchesKO16 into this.MatchesKO8
      this.KO16DrawReady = false;
      this.MatchesKO8[1] = this.MatchesKO16[9];//plate Qtr 1
      this.MatchesKO8[2] = this.MatchesKO16[10];//plate Qtr 2
      this.MatchesKO8[3] = this.MatchesKO16[11];//plate Qtr 3
      this.MatchesKO8[4] = this.MatchesKO16[12];//plate Qtr 4
      this.MatchesKO8[7] = this.MatchesKO16[19];//plate Semi 1
      this.MatchesKO8[8] = this.MatchesKO16[20];//plate Semi 2
      this.MatchesKO8[12] = this.MatchesKO16[28];//plate Final

      this.MatchesKO8[5] = this.MatchesKO16[17];//Consolation Semi Final 1
      this.MatchesKO8[6] = this.MatchesKO16[18];//Consolation Semi Final 2

      this.MatchesKO8[10] = this.MatchesKO16[26];//Consolation Final

      this.MatchesKO8[9] = this.MatchesKO16[25];//15-16 Playoff

      this.MatchesKO8[11] = this.MatchesKO16[27];//11-12 Playoff
      this.KO8DrawReady = true;
      //change the Main draw label to Plate Draw:
      setTimeout(() => {
        const koLabel = document.getElementById("KODrawLabel");
        if (koLabel) koLabel.innerText = "Plate Draw";
        const plateLabel = document.getElementById("PlateDrawLabel");
        if (plateLabel) plateLabel.innerText = "Consolation Plate";
        const specialLabel = document.getElementById("SpecialDrawLabel");
        if (specialLabel) specialLabel.innerText = "11th-12th Playoff";
        const consLabel = document.getElementById("ConsDrawLabel");
        if (consLabel) consLabel.innerText = "15th-16th Playoff";
      }, 500);
    } else if (this.isKO32Draw == true) {
      // I need to disperse the plate matches from this.MatchesKO32 into this.MatchesKO16
      //this.isPlate = true;
      this.KO32DrawReady = false;
      this.KO8DrawReady = false;
      this.MatchesKO16 = [];//start fresh
      this.MatchesKO16[1] = this.MatchesKO32[17];//plate R16 1 - losers go into consolation - which will be an 8 draw
      this.MatchesKO16[2] = this.MatchesKO32[18];//plate R16 2
      this.MatchesKO16[3] = this.MatchesKO32[19];//plate R16 3
      this.MatchesKO16[4] = this.MatchesKO32[20];//plate R16 4
      this.MatchesKO16[5] = this.MatchesKO32[21];//plate R16 5
      this.MatchesKO16[6] = this.MatchesKO32[22];//plate R16 6
      this.MatchesKO16[7] = this.MatchesKO32[23];//plate R16 7
      this.MatchesKO16[8] = this.MatchesKO32[24];//plate R16 8

      this.MatchesKO16[13] = this.MatchesKO32[37];//plate Qtr 1 - losers go into 21-24 POs semis
      this.MatchesKO16[14] = this.MatchesKO32[38];//plate Qtr 2
      this.MatchesKO16[15] = this.MatchesKO32[39];//plate Qtr 3
      this.MatchesKO16[16] = this.MatchesKO32[40];//plate Qtr 4

      this.MatchesKO16[23] = this.MatchesKO32[55];//plate Semi 1 - losers go into 19-20 Final
      this.MatchesKO16[24] = this.MatchesKO32[56];//plate Semi 2

      this.MatchesKO16[21] = this.MatchesKO32[53];//21-24 POs semis
      this.MatchesKO16[22] = this.MatchesKO32[54];//21-24 POs semis

      this.MatchesKO16[29] = this.MatchesKO32[69];//23-24 

      this.MatchesKO16[30] = this.MatchesKO32[70];//21-22 

      this.MatchesKO16[31] = this.MatchesKO32[71];//19-20

      this.MatchesKO16[32] = this.MatchesKO32[72];//plate Final (17-18)
      
      this.KO16DrawReady = true;
      //change the Main draw label to Plate Draw:
      setTimeout(() => {
        const koLabel = document.getElementById("KODrawLabel");
        if (koLabel) koLabel.innerText = "Plate Draw";
        const bronzeLabel = document.getElementById("BronzeDrawLabel");
        if (bronzeLabel) bronzeLabel.innerText = "19-20 Playoff";
        const specialLabel = document.getElementById("SpecialDrawLabel");
        if (specialLabel) specialLabel.innerText = "21-24 Playoffs";
        const label78 = document.getElementById("78Label");
        if (label78) label78.innerText = "23-24 Playoff";
      }, 500);
    }
  }

  changeToMainDraw() {
    //this.DrawSection = "Main";
    if (this.isKO16Draw == true) {
      this.KO16DrawReady = true;
      this.KO8DrawReady = false;
      //change the Plate draw label to Main Draw:
      const koLabel = document.getElementById("KODrawLabel");
      if (koLabel) koLabel.innerText = "Main Draw";
      const specialLabel = document.getElementById("SpecialDrawLabel");
      if (specialLabel) specialLabel.innerText = "Special Plate";
    } else if (this.isKO32Draw == true) {
      this.KO32DrawReady = true;
      this.KO16DrawReady = false; 
      this.KO8DrawReady = false;
      //change the Plate draw label to Main Draw:
      const koLabel32 = document.getElementById("KODrawLabel");
      if (koLabel32) koLabel32.innerText = "Main Draw";
      const specialLabel32 = document.getElementById("SpecialDrawLabel");
      if (specialLabel32) specialLabel32.innerText = "5-8 Playoffs";
    }
  }

  changeToConsoDraw() {
    //this.DrawSection = "Conso";
    if (this.isKO32Draw == true) {
      // I need to disperse the plate matches from this.MatchesKO32 into this.MatchesKO8
      //this.isPlate = true;
      this.KO32DrawReady = false;
      this.KO16DrawReady = false;
      this.MatchesKO8 = [];//start fresh
      this.MatchesKO8[1] = this.MatchesKO32[33];//consolation Qtr 1
      this.MatchesKO8[2] = this.MatchesKO32[34];//consolation Qtr 2
      this.MatchesKO8[3] = this.MatchesKO32[35];//consolation Qtr 3
      this.MatchesKO8[4] = this.MatchesKO32[36];//consolation Qtr 4

      this.MatchesKO8[5] = this.MatchesKO32[49];//29-32 Playoff Semi 1
      this.MatchesKO8[6] = this.MatchesKO32[50];//29-32 Playoff Semi 2

      this.MatchesKO8[7] = this.MatchesKO32[51];//consolation Semi 1
      this.MatchesKO8[8] = this.MatchesKO32[52];//consolation Semi 2
      
      this.MatchesKO8[9] = this.MatchesKO32[65];//31-32 Final

      this.MatchesKO8[10] = this.MatchesKO32[66];//29-30 Final

      this.MatchesKO8[11] = this.MatchesKO32[67];//27-28 Final

      this.MatchesKO8[12] = this.MatchesKO32[68];//consolation Final - 25-26
      this.KO8DrawReady = true;
      //change the Main draw label to Plate Draw:
      setTimeout(() => {
        const koLabel = document.getElementById("KODrawLabel");
        if (koLabel) koLabel.innerText = "Consolation Plate";
        const specialLabel = document.getElementById("SpecialDrawLabel");
        if (specialLabel) specialLabel.innerText = "27th-28th Playoff";
        const plateLabel = document.getElementById("PlateDrawLabel");
        if (plateLabel) plateLabel.innerText = "29th-32nd Playoff";
        const consLabel = document.getElementById("ConsDrawLabel");
        if (consLabel) consLabel.innerText = "31st-32nd Playoff";
      }, 500);
    }
  }

  changeToSpecialDraw() {
    if (this.isKO32Draw == true) {// I need to disperse the Special plate matches from this.MatchesKO32 into this.MatchesKO8
      this.KO32DrawReady = false;
      this.KO16DrawReady = false;
      this.MatchesKO8 = [];//start fresh
      this.MatchesKO8[1] = this.MatchesKO32[41];//Special Plate Qtr 1
      this.MatchesKO8[2] = this.MatchesKO32[42];//Special Plate Qtr 2
      this.MatchesKO8[3] = this.MatchesKO32[43];//Special Plate Qtr 3
      this.MatchesKO8[4] = this.MatchesKO32[44];//Special Plate Qtr 4

      this.MatchesKO8[5] = this.MatchesKO32[57];//13-16 Semi 1
      this.MatchesKO8[6] = this.MatchesKO32[58];//13-16 Semi 2

      this.MatchesKO8[7] = this.MatchesKO32[59];//Special Plate Semi 1
      this.MatchesKO8[8] = this.MatchesKO32[60];//Special Plate Semi 2
      
      this.MatchesKO8[9] = this.MatchesKO32[73];//15-16 Final

      this.MatchesKO8[10] = this.MatchesKO32[74];//13-14 Final

      this.MatchesKO8[11] = this.MatchesKO32[75];//11-12 Final

      this.MatchesKO8[12] = this.MatchesKO32[76];//Special Plate Final - 9-10
      this.KO8DrawReady = true;
      //change the Main draw label to Plate Draw:
      setTimeout(() => {
        const koLabel = document.getElementById("KODrawLabel");
        if (koLabel) koLabel.innerText = "Special Plate";
        const specialLabel = document.getElementById("SpecialDrawLabel");
        if (specialLabel) specialLabel.innerText = "11-12 Playoff";
        const plateLabel = document.getElementById("PlateDrawLabel");
        if (plateLabel) plateLabel.innerText = "13-16 Playoff";
        const consLabel = document.getElementById("ConsDrawLabel");
        if (consLabel) consLabel.innerText = "15-16 Playoff";
      }, 500);
    }
  }

  toggleEditMode() {
    this.isEditing = !this.isEditing;
  }

  ko32SlotsR1() {
    const slots: { 
      css: string;
      matchIndex: number;
      playerKey: 'player1Name' | 'player2Name';
    }[] = [];
  
    let pos = 1;
  
    for (let i = 1; i <= 16; i++) {
      slots.push({ css: `p${pos++}`, matchIndex: i, playerKey: 'player1Name' });
      slots.push({ css: `p${pos++}`, matchIndex: i, playerKey: 'player2Name' });
    }
  
    return slots;
  }

  ko32SlotsR2() {
    const slots: { 
      css: string;
      matchIndex: number;
      sourceMatchIndex: number;  // R1 match (1–16)
      playerKey: 'player1Name' | 'player2Name';
    }[] = [];
  
    let pos = 1;
    let Count = 1;
    for (let i = 25; i <= 32; i++) {
      slots.push({ css: `p${pos++}`, matchIndex: i, sourceMatchIndex: Count, playerKey: 'player1Name' });
      slots.push({ css: `p${pos++}`, matchIndex: i, sourceMatchIndex: Count+1, playerKey: 'player2Name' });
      Count = Count + 2;
    }
  
    return slots;
  }

  private getPlayerIdKey(nameKey: 'player1Name' | 'player2Name'): 'player1' | 'player2' {
    return nameKey === 'player1Name' ? 'player1' : 'player2';
  }
  

  async onPlayerChange(matchIndex: number, playerKey: 'player1Name' | 'player2Name', newPlayerID: number) {
    var Player = this.DataService.Players?.find(p => p.id === newPlayerID);
    var boolNewMatch = false
    if (!this.MatchesKO32[matchIndex]) {
      this.MatchesKO32[matchIndex] = this.FunctionService.createMatch(matchIndex, this.DataService.SelectedTorn!.id!, this.DataService.SelectedDraw!.id!, undefined, undefined, undefined, undefined, 0, this.DataService.SelectedTorn!.dateOfEvent!);
      boolNewMatch = true;
    }
    if (!Player) {
      newPlayerID = 0;
    }
    if(playerKey == 'player1Name') {
      this.MatchesKO32[matchIndex].player1 = newPlayerID;
      if (Player) {
        this.MatchesKO32[matchIndex].player1Name = Player.name;
      } else {
        this.MatchesKO32[matchIndex].player1Name = "";
      }
    } else{
      this.MatchesKO32[matchIndex].player2 = newPlayerID;
      if (Player) {
        this.MatchesKO32[matchIndex].player2Name = Player.name;
      } else {
        this.MatchesKO32[matchIndex].player2Name = "";
      }
    }
    if (boolNewMatch == false && (this.MatchesKO32[matchIndex].player1 == 0 && this.MatchesKO32[matchIndex].player2 == 0)) {//match no longer exists
      this.ApiService.deleteMatch(this.MatchesKO32[matchIndex]);
      this.MatchesKO32[matchIndex] = null as any;
      return;
    }
    if (boolNewMatch == true) {
      this.MatchesKO32[matchIndex] = await this.ApiService.SaveNewMatch(this.MatchesKO32[matchIndex]);
    } else {
      this.ApiService.updateMatch(this.MatchesKO32[matchIndex]);
    }
  }

}
